var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"editor",class:{'hidden':_vm.getHideColumn(_vm.itemdata)},attrs:{"id":'editor'+_vm.itemdata.colid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }